import Products from "../../component/products/Products"

const Home = () => {
    return (
        <section>
            <Products />
        </section>
    )
}

export default Home
